import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Paper,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cartActions, orderActions } from "../actions";
import styled from "@emotion/styled";
import OrderTotals from "./OrderTotals";
import Cart from "../pages/Cart";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from '@mui/icons-material/Print';

const styles = {
  dialog: {
    "& .MuiBackdrop-root": {
      backgroundColor: "rgb(0,0,0,0.3)",
    },
  },
  title: { backgroundColor: "black", color: "white" },
  content: {
    "&::-webkit-scrollbar": {
      width: 4,
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "grey",
      width: 4,
    },
  },
  orderTotals: { position: "sticky", top: "0", height: "100%" },
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "grey",
    color: theme.palette.common.white,
    fontSize: 19,
  },
  [`&.${tableCellClasses.body}`]: {
    backgroundColor: "#f5f5f5",
    fontSize: 17,
  },
}));

const TableItems = () => {
  const { items } = useSelector((state) => state.order);

  function sumValues(objeto) {
    let suma = 0;

    for (const clave in objeto) {
      if (
        typeof objeto[clave] === "number" &&
        clave !== "productId" &&
        clave !== "webOrderId"
      ) {
        if (clave === "bonifGralBool" && !objeto[clave]) {
          continue;
        }
        suma += objeto[clave];
      }
    }
    return suma.toFixed(2);
  }

  const calculateValue = (unitPrice, descuento) => {
    return sumValues(descuento) === 0
      ? unitPrice
      : (unitPrice * (1 - sumValues(descuento) / 100)).toFixed(2);
  };


  return (
    items && (
      <TableContainer component={Paper} >
        <Table size="medium" >
          <TableHead>
            <TableRow>
              <StyledTableCell align="center" />
              <StyledTableCell align="center">Item </StyledTableCell>
              <StyledTableCell align="center">Descripción</StyledTableCell>
              <StyledTableCell align="center">Cantidad</StyledTableCell>
              <StyledTableCell align="center">Precio Lista</StyledTableCell>
              <StyledTableCell align="center">Su precio</StyledTableCell>
              <StyledTableCell align="center">SubTotal</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((prod, i) => (
              <TableRow key={`${prod.productDescription}-${i}`}>
                <StyledTableCell align="center">
                  {i + 1}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {prod.productId}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {prod.productDescription}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {prod.quantity}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {prod.unitPrice}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {calculateValue(prod.unitPrice, prod.discount)}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {(
                    calculateValue(prod.unitPrice, prod.discount) *
                    prod.quantity
                  ).toLocaleString()}
                </StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )
  );
};

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PopUpOrder = ({ row, setter }) => {
  const { integrationId, webOrderId } = useSelector((state) => state.order);
  const { dynamicsId } = useSelector((state) => state.account);
  const dispatch = useDispatch();
  const theme = useTheme()
  const mobile = useMediaQuery(theme.breakpoints.down("md"))

  const handleClose = () => {
    !row.checkoutPop && dispatch(orderActions.clear());
    setter({ item: {}, open: false });
  };

  return (
    <Dialog
      open={row.open}
      onClose={() => handleClose()}
      TransitionComponent={Transition}
      keepMounted
      maxWidth={row.checkoutPop ? "lg" : "xl"}
      fullWidth
      sx={styles.dialog}
    >
      {row.checkoutPop ? (
        <DialogTitle sx={styles.title} align="center">
          Pre-visualizacion de pedido
        </DialogTitle>
      ) : (
        <DialogTitle sx={styles.title} align="center">
          Esta viendo la orden numero
          {` ${integrationId ? integrationId : webOrderId}`}
        </DialogTitle>
      )}
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
          "@media print": {
            display: "none"
          },
        }}
      >
        <CloseIcon />
      </IconButton>
      <Divider />
      <DialogContent sx={styles.content}>
        {!row.checkoutPop ? (
          <Grid container spacing={2}>
            <Grid item sm={mobile ? 12 : 9} sx={{ overflow: "scroll" }}>
              <TableItems />
            </Grid>
            <Grid item sm={mobile ? 12 : 3} style={styles.orderTotals}>
              {row.item && (
                <OrderTotals
                  webOrderId={webOrderId}
                  dynamicsId={dynamicsId}
                  item={row.item}
                  order={true}
                />
              )}
            </Grid>
          </Grid>
        ) : (
          <Cart isCheckout={row.checkoutPop} />
        )}
      </DialogContent>
      <DialogActions>
        {!row.checkoutPop && (
          <Button
            sx={{
              backgroundColor: "black",
              color: "white",
              transition: "all 0.2s ease-in-out",
              '&:hover': {
                backgroundColor: "black",
                opacity: "0.8"
              },
            }}
            autoFocus
            color="success"
            variant="contained"
            onClick={() => handleClose()}
          >
            Volver
          </Button>
        )}
        {row.checkoutPop && <Button onClick={() => window.print()} size="small" startIcon={<PrintIcon />} sx={{
          width: mobile ? "100%" : "20%",
          backgroundColor: "black",
          color: "white",
          transition: "all 0.2s ease-in-out",
          '&:hover': {
            backgroundColor: "black",
            opacity: "0.8"
          },
          "@media print": {
            display: "none",
          },
        }}>
          Imprimir Pedido
        </Button>}
      </DialogActions>
    </Dialog>
  );
};

export default PopUpOrder;
